import { trackCioEvent } from '../cio';
import { AnalyticsEvent } from '../types';

export type TelehealthBookingReservationSubmittedEventProperties = {
  th_appointment_datetime: string;
};

export function trackTelehealthBookingReservationSubmitted(
  properties: TelehealthBookingReservationSubmittedEventProperties
) {
  trackCioEvent(AnalyticsEvent.DTC_TELEHEALTH_BOOKING_SELECTED);

  // TODO: Deprecate this event in favor of the above:
  trackCioEvent(AnalyticsEvent.TELEHEALTH_BOOKING_STEP_RESERVATION_SUBMITTED_DATE_TIME, {
    th_appointment_datetime: properties.th_appointment_datetime,
  });
}
